import {Component} from '@angular/core';

/**
 * Wraps bsg-nav-items and applies the appropriate styling.
 */
@Component({
  selector: 'cap-bsg-nav-menu',
  host: {
    id: 'navmenu',
    class: 'flex-column w-100',
  },
  template: '<ng-content></ng-content>',
})
export class NavMenuComponent {
}
